import styled, {css} from "styled-components";

export const BreadcrumbsItemDefaultBox = styled.span<{isClickable: boolean}>`
        &:last-of-type {
            ${({theme}) => theme.font.presets.bold};
        }
        
        & > a {
                ${props => props.isClickable ? `` : css`
                        cursor: initial;
                `}
        }
        
`